import React, { ReactNode } from 'react';

import styles from './overlay.module.scss';

interface IProps {
  children: ReactNode;
  overlaying: boolean;
  toggleOverlay: (value: 'on' | 'off') => void;
}

export const Overlay = ({ children, overlaying, toggleOverlay }: IProps) => {
  return (
    <div className={styles.wrapper}>
      {children}
      {overlaying && <div className={styles.overlay} onClick={() => toggleOverlay('off')} />}
    </div>
  );
};
